import { NgModule } from '@angular/core';
import { PeriodOptionListComponent } from './components/period-option-list/period-option-list.component';
import { RangeSelectorComponent } from './components/range-selector/range-selector.component';
import { TimeValuePickerComponent } from './components/time-value-picker/time-value-picker.component';
import { IntegerInputDirective } from './directives/integer-input.directive';
import { RangeSelectorInputComponent } from './range-selector-input.component';

@NgModule({
  imports: [
    RangeSelectorInputComponent,
    RangeSelectorComponent,
    TimeValuePickerComponent,
    PeriodOptionListComponent,
    IntegerInputDirective,
  ],
  exports: [RangeSelectorInputComponent],
})
export class RangeSelectorInputModule {}
